import React from 'react';
import { CheckIcon } from 'lucide-react';
import { solutionPoints, solutionTitle } from '../data/content';
export function Solution() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-229" data-mp="1ejsvpvc4nkmo">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-230" data-mp="10tz7nf8g54e0">
        <h2 className="mx-auto max-w-4xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-231" data-mp="10rczbddqekuq">
          {solutionTitle}
        </h2>

        <ul className="mx-auto mt-12 grid max-w-3xl gap-4" data-id="element-232" data-mp="qtovzz22850y">
          {solutionPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-233" data-mp="vs03w48so5gj">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-234" data-mp="hvd4lutdd37g">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-235" data-mp="mtoeu6nktfq7" />
              </span>
              <span className="text-lg text-slate-900" data-id="element-236" data-mp="2c8w3b7z4yruc">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}